<div
  class="flex h-[72px] items-center justify-between overflow-hidden rounded-b-[20px] border border-t-0 border-background-light-blue bg-background-white shadow-header"
>
  <div class="flex h-full items-center overflow-hidden pl-6">
    <a class="block flex-shrink-0" [routerLink]="homeRoute">
      <img class="mr-3 h-9 w-12 items-center" src="assets/images/notes-logo-header.svg" />
    </a>
  </div>

  <div class="flex items-center justify-between gap-10">
    @if (loggedInUser) {
      <div class="flex h-[72px] items-center gap-3 rounded-bl-[20px] px-10">
        <lib-ffd-notes-header-profile
          [user]="loggedInUser"
          [selectedSite]="selectedSite"
          [sitesCount]="sitesCount"
        ></lib-ffd-notes-header-profile>
      </div>
    }
  </div>
</div>
